import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';

/**
 * 상세 화면의 "← 뒤로" — 어드민 안에서 넘어왔으면 실제 이전 화면으로(브라우저 뒤로와 같다),
 * 주소로 바로 들어와 이전 화면이 없으면 목록(fallback)으로 간다.
 * 고정 목록 링크로 두면 협찬 지원 내역 → 회원 상세 → 뒤로 가 회원 목록으로 튀는 문제가 생긴다.
 */
export function BackLink({
  fallback,
  fallbackLabel,
  className,
}: {
  fallback: '/users' | '/orders' | '/chats' | '/policies' | '/community' | '/support';
  /** 이전 화면이 없을 때 보일 목록 이름 — "회원 목록" */
  fallbackLabel: string;
  className: string;
}) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  if (canGoBack) {
    return (
      <button type="button" onClick={() => router.history.back()} className={className}>
        ← 뒤로
      </button>
    );
  }
  return (
    <Link to={fallback} className={className}>
      ← {fallbackLabel}
    </Link>
  );
}
